import { useRef } from 'react'
import { ImageIcon, X } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

interface ClipThumbnailPickerProps {
  value: string // dataURL or URL
  onChange: (dataUrl: string) => void
}

export default function ClipThumbnailPicker({
  value,
  onChange,
}: ClipThumbnailPickerProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleManualOverride = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return
    const reader = new FileReader()
    reader.onloadend = () => {
      onChange(reader.result as string)
    }
    reader.readAsDataURL(file)
  }

  return (
    <div className="min-w-0 space-y-2">
      <Label className="text-sm font-medium text-black">
        รูปภาพปก (ไม่บังคับ)
      </Label>

      {value ? (
        <div className="inline-flex max-w-full flex-col gap-2">
          <div className="flex max-w-full justify-center overflow-hidden rounded-xl border bg-gray-50">
            <img
              src={value}
              alt="Thumbnail preview"
              className="h-40 max-w-full object-contain"
            />
          </div>
          <div className="flex max-w-full flex-wrap items-center gap-2">
            <Button
              type="button"
              size="sm"
              variant="secondary"
              onClick={() => inputRef.current?.click()}
              className="h-9 shrink-0 px-3 text-xs"
            >
              เปลี่ยน
            </Button>
            <Button
              type="button"
              size="sm"
              variant="destructive"
              onClick={() => onChange('')}
              className="h-9 w-9 shrink-0 p-0"
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        </div>
      ) : (
        <div
          onClick={() => inputRef.current?.click()}
          className="flex h-40 w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 px-4 text-center transition-colors hover:border-primary hover:bg-primary/5"
        >
          <ImageIcon className="h-8 w-8 text-gray-400" />
          <p className="text-xs text-muted-foreground">
            คลิกเพื่ออัปโหลดรูปภาพปกเอง หรือเว้นว่างให้ระบบสร้างให้อัตโนมัติ
          </p>
        </div>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleManualOverride}
      />
      <p className="text-xs text-muted-foreground">
        หากไม่อัปโหลดรูปภาพปก ระบบจะสร้างรูปภาพปกจากวิดีโอให้อัตโนมัติ
      </p>
    </div>
  )
}
